import type { Data } from '@wix/thunderbolt-becky-types'
import { presetIdsNode as presetIds } from './presetIdsNode'
import { getInvalidationHandler } from './invalidationHandler'
import { IocContainer } from '@wix/thunderbolt-ioc'
import { CompNodeProviderSymbol, OnInvalidationSymbol } from '@wix/thunderbolt-catharsis-ioc'
import { PresetsDataList } from './types'

const RELEVANT_DATA_MAPS: Array<keyof Data> = ['document_data', 'presets']

export const addInvalidation = (container: IocContainer): PresetsDataList => {
	const presets: PresetsDataList = []

	const onInvalidation = getInvalidationHandler(presets)
	container.bind(OnInvalidationSymbol).toConstantValue(onInvalidation)

	container.bind(CompNodeProviderSymbol).toConstantValue({
		getCompNodes: () => ({ presetIds }),
		getUsedDataMaps: () => RELEVANT_DATA_MAPS,
	})

	return presets
}
